<template>
  <main class="pb-5 mb-5">
    <section class="pt-5">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h1 class="text-uppercase">Welcome to Colourhouse Studio</h1>
            <p class="h5">Click on the seminar/education you want to join</p>
          </div>
        </div>
      </div>
    </section>

    <section class="container mt-5">
      <div class="row" v-if="loading">
        <div class="col text-center">
          <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>

      <div class="row" v-else>
        <router-link :to="{ name: 'event', params: { id: event.id } }" class="col text-center" v-for="event in events" :key="event.id">
          <event-image :event="event"></event-image>
          <span class="d-block mt-2">{{ event.header }}</span>
        </router-link>
      </div>
    </section>
  </main>
</template>

<script>
  import { firebase } from "@/initializers/firebase"

  import EventImage from "@/components/event-image.vue"

  export default {
    name: "home",
    components: { EventImage },
    data() {
      return {
        loading: true,
        sending: false,
        events: []
      }
    },
    async mounted() {
      let eventsRef = await firebase.firestore().collection(`events`).where("active", "==", true).where("visible", "==", true).orderBy("eventStart")
      let events = await eventsRef.get()
      this.events = events.docs.map((doc) => {
        return Object.assign({}, { id: doc.id }, doc.data())
      })

      this.loading = false
    }
  }
</script>

<style lang="scss" scoped>
  
</style>